// @ts-nocheck
export const URL = process.env.PUBLIC_URL + '/assets/models/candyD.gltf.glb'

export const useModel = (): GLTFResult => {
  const { nodes, materials } = useGLTF(URL) as GLTFResult
  Object.values(nodes).forEach(n => n.traverse(ch => (ch.type === 'Mesh' ? (ch.castShadow = true) : null)))
  return { nodes, materials }
}
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from 'three'
import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'

type GLTFResult = GLTF & {
  nodes: {
    candyD: THREE.Group
    Cylinder063: THREE.Mesh
    Cylinder063_1: THREE.Mesh
  }
  materials: {
    White: THREE.MeshStandardMaterial
    Orange: THREE.MeshStandardMaterial
  }
}

export function Model(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF(URL) as GLTFResult
  return (
    <group {...props} dispose={null}>
      <group name="candyA" userData={{ name: 'candyA' }}>
        <mesh
          name="Cylinder063"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder063.geometry}
          material={materials.White}
        />
        <mesh
          name="Cylinder063_1"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder063_1.geometry}
          material={materials.Orange}
        />
      </group>
    </group>
  )
}

useGLTF.preload(URL)
